import { useCallback } from 'react';

import { useErrors } from '../global-state/Errors';
import AuthService from '../services/AuthService';
import BaseService from '../services/BaseService';

const useUnauthenticate = () => {
  const setError = useErrors((x) => x.setValue);

  return useCallback(() => {
    return AuthService.logout().then((res) => {
      setError(null);
      BaseService.unsetClientTenantDetails();
      BaseService.clearToken();

      if (res.data.ssoLogoutUrl) {
        window.location.href = res.data.ssoLogoutUrl;
      }
    });
  }, [setError]);
};

export default useUnauthenticate;
